module.exports = __webpack_public_path__ + "static/img/3.7987b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.jpg
// module id = iCB0
// module chunks = 0